import React, { useEffect, } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createCircular, getCircular, resetState, updateCircular } from "../../Association/features/circular/CircularSlice";
import { toast } from "react-toastify";
import CustomInput from "../components/CustomInput";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

let schema = yup.object().shape({
  title: yup.string().required("Title is Required"),
  content: yup.string().required("content is Required"),


});

const AddMember = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const getNewsId = location.pathname.split("/")[3];
  const NewsState = useSelector((state) => state.circular);
  const { isSuccess, isError, isLoading, createdCircular, circulartitle, circularcontent, updatedCircular } = NewsState;

  const token = useSelector((state) => state.autht.token);
  useEffect(() => {
    if (getNewsId !== undefined) {
      dispatch(getCircular(getNewsId));
    } else {
      dispatch(resetState());
    }
  }, [dispatch, getNewsId]);

  useEffect(() => {
    dispatch(resetState());

  }, [dispatch]);

  useEffect(() => {
    if (isSuccess && createdCircular) {
      toast.success("Circular Added Successfully!");
      dispatch(resetState());
    }
    if (isSuccess && updatedCircular) {
      toast.success("Circular Updated Successfully!");
      navigate("/association/Circular-list");
    }
    if (isError) {
      toast.error("Something Went Wrong!");
    }
  }, [isSuccess, isError, isLoading]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {

      title: circulartitle || "",
      content: circularcontent || "",
      token: token

    },
    validationSchema: schema,
    onSubmit: (values) => {

      if (getNewsId !== undefined) {
        const data = { id: getNewsId, NewsData: values };
        dispatch(updateCircular(data));
        dispatch(resetState());
      } else {
        dispatch(createCircular(values));
        formik.resetForm();
        setTimeout(() => {
          dispatch(resetState());
        }, 300);
      }
    },
  });

  const modules = {
    toolbar: [
      [{ font: [] }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ script: "sub" }, { script: "super" }],
      ["blockquote", "code-block"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image", "video"],
      ["clean"],
    ],
  };



  return (
    <div>
      <h3 className="mb-4 title">{getNewsId !== undefined ? "Edit" : "Add"} Circulars</h3>

      <div className="">
        <form action="" onSubmit={formik.handleSubmit}>
          <div className="mt-4">
            <CustomInput
              type="text"
              label="Enter Title"
              name="title"
              onChng={formik.handleChange("title")}
              onBlr={formik.handleBlur("title")}
              val={formik.values.title}
            />
            <div className="error">{formik.touched.title && formik.errors.title}</div>
          </div>

          <ReactQuill
            theme="snow"
            className="mt-3"
            name="content"
            modules={modules}
            onChange={formik.handleChange("content")}
            value={formik.values.content}
          />
          <div className="error">{formik.touched.content && formik.errors.content}</div>
          <button className="btn btn-success border-0 rounded-3 my-5" type="submit">
            {getNewsId !== undefined ? "Edit" : "Add"} Circulars
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddMember;